import React from 'react';
import { Share2, Facebook, Twitter, Linkedin, MessageCircle, Link as LinkIcon, Mail } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { toast } from 'sonner';

export default function ShareButtons({ title, url }) {
  const t = encodeURIComponent(title), u = encodeURIComponent(url);
  const links = [
    { name: 'Gmail / Google', icon: Mail, url: `https://mail.google.com/mail/?view=cm&su=${t}&body=${t}%0A%0A${u}`, color: '#EA4335', tid: 'share-google-btn' },
    { name: 'Facebook', icon: Facebook, url: `https://www.facebook.com/sharer/sharer.php?u=${u}`, color: '#1877F2', tid: 'share-facebook' },
    { name: 'Twitter / X', icon: Twitter, url: `https://twitter.com/intent/tweet?text=${t}&url=${u}`, color: '#0B1F40', tid: 'share-twitter-/-x' },
    { name: 'LinkedIn', icon: Linkedin, url: `https://www.linkedin.com/sharing/share-offsite/?url=${u}`, color: '#0A66C2', tid: 'share-linkedin' },
    { name: 'WhatsApp', icon: MessageCircle, url: `https://wa.me/?text=${t}%20${u}`, color: '#25D366', tid: 'share-whatsapp' },
  ];
  const copy = () => { navigator.clipboard.writeText(url); toast.success('Enlace copiado'); };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="share-btn" className="bg-[#0B1F40] text-white text-[10px] font-black h-9 px-5 flex items-center gap-1.5 brutal-btn-press transition-all" style={{ boxShadow: '3px 3px 0px #E50B15' }}>
          <Share2 className="h-3.5 w-3.5" /> COMPARTIR
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="rounded-none border-2 border-[#0B1F40] bg-white w-56 brutal-shadow">
        {links.map(l => (
          <DropdownMenuItem key={l.name} data-testid={l.tid} className="cursor-pointer py-2.5" asChild>
            <a href={l.url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-xs font-bold text-[#0B1F40] w-full">
              <l.icon className="h-4 w-4" style={{ color: l.color }} />{l.name}
            </a>
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="share-copy-link" onClick={copy} className="cursor-pointer py-2.5">
          <LinkIcon className="h-4 w-4 mr-2.5 text-[#0B1F40]/40" /><span className="text-xs font-bold text-[#0B1F40]">Copiar Enlace</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
